<template>
<div style="display:flex;flex-direction:row" v-loading="loading" :element-loading-text="loadingText">
  <div v-if="targetCompounds" style="flex:1 1">
    <div class="shaded-box padded-box">
      <div class="summary-row-label">
        Targets
      </div>
      <div><canvas id="targetnames"></canvas></div>
    </div>

    <div class="shaded-box padded-box">
      <div class="summary-row-label">
        Target Species
      </div>
      <div><canvas id="targetspecies"></canvas></div>
    </div>

    <div class="shaded-box padded-box">
      <div class="summary-row-label">
        Functions
      </div>
      <div><canvas id="targetfunctions"></canvas></div>
    </div>

    <div class="shaded-box padded-box">
      <div class="summary-row-label">
        Processes
      </div>
      <div><canvas id="targetprocesses"></canvas></div>
    </div>

  </div>

  <!-- Download -->
  <div style="flex:0 0 300px;margin-left:15px;margin-top:20px;">
    <div class="results-menu-download">
      <div class="popup-menu-button" @click="downloadMenuVisible=true"><i class="el-icon-download"></i> Download</div>

      <!-- Download Menu -->
      <div class="popup-menu" v-if="downloadMenuVisible">
        <div class="popup-menu-head">
          <div class="popup-menu-title">DOWNLOAD</div>
          <div class="popup-menu-close" @click="downloadMenuVisible=false"><i class="el-icon-close"></i></div>
        </div>
        <div class="popup-menu-body">
          <!-- <div class="popup-menu-item" @click="savePdf();downloadMenuVisible=false;">
            Report (pdf)
          </div> -->
          <div class="popup-menu-item" @click="saveTargets('Name');downloadMenuVisible=false">
            Target Names (csv)
          </div>
          <div class="popup-menu-item" @click="saveAllTargets('Name');downloadMenuVisible=false">
            Target Names for All Query Compounds (csv)
          </div>

          <div class="popup-menu-item" @click="saveTargets('Organism');downloadMenuVisible=false">
            Target Species (csv)
          </div>
          <div class="popup-menu-item" @click="saveAllTargets('Organism');downloadMenuVisible=false">
            Target Species for All Query Compounds (csv)
          </div>

          <div class="popup-menu-item" @click="saveTargets('Function');downloadMenuVisible=false">
            Target Fuction (csv)
          </div>
          <div class="popup-menu-item" @click="saveAllTargets('Function');downloadMenuVisible=false">
            Target Fuction for All Query Compounds (csv)
          </div>

          <div class="popup-menu-item" @click="saveTargets('Process');downloadMenuVisible=false">
            Target Processes (csv)
          </div>
          <div class="popup-menu-item" @click="saveAllTargets('Process');downloadMenuVisible=false">
            Target Processes for All Query Compounds (csv)
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Chart from 'chart.js'
import { bus } from '../bus.js'
import interpolate from 'color-interpolate'
import utils from '../utils.js'
import Vuex from 'vuex'
import makeTaskStore from '../store/task-store.js'

function formatCSVValue(value) {
  if (typeof value === 'string' && value.includes(',')) {
    return `"${value.replace(/"/g, '""')}"`
  } else {
    return `${value}`;
  }
}

export default {
  name: 'Statistics',

  data () {
    return {
      downloadMenuVisible: false,
      loading: false,
      loadingText: ''
    }
  },

  computed: {
    // results () {
    //   return this.task ? ('compounds' in this.task.results ? this.task.results.compounds : this.task.results) : []
    // },

    ...Vuex.mapGetters([
      'assays',
      'targets',
      'compounds',
      'processes',
      'functions',
      'targetCompounds',
      'targetNames',
      'targetSpecies',
      'targetFunctions',
      'targetProcesses'
    ]),

    ncompounds () {
      let smi = this.$store.getters.par.compound
      if (smi) {
        return smi.split('\n').filter(line => line.trim() !== '').length
      } else {
        return 0
      }
    }
  },

  watch: {
    targets: {
      immediate: true,
      handler (newTargets, oldTargets) {
        // console.log('set charts')
        if (newTargets) {
          this.$nextTick(() => {
            this.setCharts()
          })
        }
      }
    }
  },

  methods: {
    ...utils.mapUtils([
      'saveCsv',
      'download'
    ]),

    setChart (chartname, element, labels, data) {
      let v = this
      let n = labels.length
      if (n > 0) {
        element.parentElement.style.width = `100%`
        element.parentElement.style.height = `${labels.length * 15 + 30}px`
        let colormap = interpolate(['#053795', 'green', 'yellow', '#900c3f'])
        let mx = Math.max(...data)
        let mn = Math.min(...data)
        let d = mx - mn
        let colors = data.map(i => colormap(d === 0 ? 0.5 : (i - mn) / (mx - mn)))
        if (chartname in v) {
          let chart = v[chartname]
          chart.data.labels.length = 0
          labels.forEach(label => { chart.data.labels.push(label) })
          chart.data.datasets.forEach(dataset => { dataset.data = data })
          chart.update()
        } else {
          v[chartname] = new Chart(element, {
            type: 'horizontalBar',
            data: {
              datasets: [{
                data: data,
                backgroundColor: colors
              }],
              labels: labels
            },
            options: {
              maintainAspectRatio: false,
              responsive: true,
              legend: {
                display: false
              }
            }
          })
        }
      }
    },

    setCharts () {
      let v = this

      let n = 300
      // Target Names
      let stat = this.targetNames
      let labels = Object.keys(stat).sort((a, b) => stat[b] - stat[a]).slice(0, n)
      let data = labels.map(label => stat[label])
      this.setChart('targetnames', document.getElementById('targetnames'), labels, data)

      // Target Species
      stat = this.targetSpecies
      labels = Object.keys(stat).sort((a, b) => stat[b] - stat[a]).slice(0, n)
      data = labels.map(label => stat[label])
      this.setChart('targetspecies', document.getElementById('targetspecies'), labels, data)

      // Functions
      stat = this.targetFunctions
      labels = Object.keys(stat).sort((a, b) => stat[b] - stat[a]).slice(0, n)
      data = labels.map(label => stat[label])
      this.setChart('targetfunctions', document.getElementById('targetfunctions'), labels, data)

      // Processes
      stat = this.targetProcesses
      labels = Object.keys(stat).sort((a, b) => stat[b] - stat[a]).slice(0, n)
      data = labels.map(label => stat[label])
      this.setChart('targetprocesses', document.getElementById('targetprocesses'), labels, data)
    },

    targetLines (store, icompound, type) {
      let n = 300
      // Target Names
      let stat = type === 'Name' ? store.getters.targetNames : (
        type === 'Organism' ? store.getters.targetSpecies : (
          type === 'Function' ? store.getters.targetFunctions : (
            type === 'Process' ? store.getters.targetProcesses : {}
          )
        )
      )

      let labels = Object.keys(stat).sort((a, b) => stat[b] - stat[a]).slice(0, n)
      let data = labels.map(label => stat[label])

      let content = ''
      for (let label of labels) {
        let score = stat[label]
        let lineList = [parseInt(icompound) + 1, label, score]
        content += lineList.map(formatCSVValue).join(',')
        content += '\n'

        // content += `${parseInt(icompound) + 1},"${label}",${score}\n`
      }
      return content
    },

    saveTargets (type) {
      let content = `No. Query Compound,Target ${type},Score\n`
      content += this.targetLines(this.$store, this.$store.state.route.params.icompound, type)
      this.download(content, `Drift-${this.$store.state.route.params.id}-${this.$store.state.route.params.icompound}-Target-${type}s.csv`)
    },

    async saveAllTargets (type) {
      this.loading = true
      let store = new Vuex.Store(makeTaskStore())
      let r = {}
      for (let k of ['minimalCompoundSimilarity', 'hideNullCompounds', 'hideOwnTargets', 'targetTypes', 'targetSpecies', 'assayRange']) {
        r[k] = this.$store.state[k]
      }
      store.commit('set', r)

      let taskid = this.$store.state.route.params.id
      let content = `No. Query Compound,Target ${type},Score\n`
      for (let icompound = 0; icompound < this.ncompounds; icompound++) {
        this.loadingText = `Downloading Targets of Compound ${icompound + 1}`
        await store.dispatch('fetchTask', {taskid, icompound})
        content += this.targetLines(store, icompound, type)
      }
      this.download(content, `Drift-${this.$store.state.route.params.id}-Target-${type}s.csv`)
      this.loading = false
    }
  },

  mounted () {
    // this.setCharts()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/theme.scss";


.summary-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 30px;
}

.summary-row-label {
  color: #85929e;
  font-weight: bold;
  font-size: 30px;
}

</style>
